export default {
  items: [
    {
      name: '儀表板',
      url: '/workspace',
      icon: 'icon-chart',
    },
    {
      name: '搜尋結果',
      url: '/results',
      icon: 'icon-magnifier',
    },
    // {
    //   name: '我的搜尋關鍵字組',
    //   url: '/search-factor',
    //   icon: 'icon-puzzle',
    // },
    {
      name: '智慧導覽',
      url: '/guide',
      icon: 'icon-direction',
    },
    {
      name: '預警設定',
      url: '/alert',
      icon: 'icon-speedometer',
    },
    {
      name: 'Neuftek 其他服務',
      url: '/neuftek',
      icon: 'icon-globe',
    },
    {
      name: '作者查詢',
      url:'/authorSearch',
      icon:'icon-pencil',
      id:'37b07022-767c-11eb-aba5-005056b128d1',
    },
    {
      name:'熱門關鍵詞',
      url:'/popkeyword',
      icon:'icon-fire',
      id:'838c4942-7804-11eb-8d6b-005056b128d1'
    },
    {
      name:'youtube 作者搜尋',
      url:'/youtuberSearch',
      icon:'fa fa-youtube-play',
    },
    // {
    //   name:'facebook 作者搜尋',
    //   url:'/facebookSearch',
    //   icon:'fa fa-facebook-square',
    // },
  ],
};



// WEBPACK FOOTER //
// ./src/_nav.js